module.exports = __webpack_public_path__ + "media/images/ic-calendar-cf33df23f61d4a50525fdebc46d234d0.svg";